/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Passkey_Setup_SkipInputs */



/**
* | output |
* | --- |
* | "Skip for now" |
*
* @param {Auth_Passkey_Setup_SkipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_passkey_setup_skip = /** @type {((inputs?: Auth_Passkey_Setup_SkipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Passkey_Setup_SkipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Jetzt überspringen")
	return /** @type {LocalizedString} */ ("Skip for now")
});